import ReportStatisticCard from "@/admin/insights/member-reports/common/MemberReportStatisticCard"
import { MemberReportAverageEventsFeedbackStatisticCardFragment$key } from "@/admin/insights/member-reports/common/__generated__/MemberReportAverageEventsFeedbackStatisticCardFragment.graphql"
import { useLabels } from "@/core/context/LabelsContext"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoIcon, DiscoText } from "@disco-ui"
import { graphql, useFragment } from "react-relay"

interface Props {
  organizationMembershipKey: MemberReportAverageEventsFeedbackStatisticCardFragment$key
}

export default function MemberReportAverageEventsFeedbackStatisticCard({
  organizationMembershipKey,
}: Props) {
  const classes = useStyles()
  const labels = useLabels()
  const organizationMembership =
    useFragment<MemberReportAverageEventsFeedbackStatisticCardFragment$key>(
      graphql`
        fragment MemberReportAverageEventsFeedbackStatisticCardFragment on OrganizationMembership
        @argumentDefinitions(startDate: { type: "String" }) {
          averageEventsFeedbackReport(startDate: $startDate) {
            allTime
          }
        }
      `,
      organizationMembershipKey
    )

  return (
    <ReportStatisticCard
      testid={"MemberReportAverageEventsFeedbackStatisticCard"}
      value={
        <div className={classes.value}>
          <DiscoText
            variant={"heading-xxl"}
            className={classes.valueText}
            marginRight={1}
          >
            {organizationMembership.averageEventsFeedbackReport?.allTime || 0}
          </DiscoText>
          <DiscoIcon className={classes.starIcon} icon={"star"} active />
        </div>
      }
      subtitle={`Average Event Feedback`}
      tooltip={`The average feedback score this ${labels.admin_member.singular} has given for the events they attended.`}
    />
  )
}

const useStyles = makeUseStyles((theme) => ({
  value: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  valueText: {
    fontWeight: 300,
  },
  starIcon: {
    width: "20px",
    height: "20px",
    color: theme.palette.groovy.yellow[400],
    "& svg": {
      color: theme.palette.groovy.yellow[400],
    },
  },
}))
